import { render } from "./OrganizationComponent.vue?vue&type=template&id=1edbd1a6"
import script from "./OrganizationComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__